/* Minimalna vrednost porudžbine — 1.000 RSD.  v3, 06.10.2026.
   Radi na stranici korpe, u korpi koja iskace sa strane i na dugmetu Kupi odmah.
   Uvek prikazuje obavestenje u korpi, a crvenu opomenu samo kad je ispod minimuma. */
(function () {
  var MIN = 100000; /* u parama: 1000,00 RSD */

  function dinara(p) {
    return (p / 100).toLocaleString('sr-RS', { maximumFractionDigits: 0 });
  }

  function nadjiMesta() {
    return document.querySelectorAll(
      '.cart__ctas, cart-drawer .drawer__footer, #CartDrawer .drawer__footer'
    );
  }

  function obavestenje(kontejner, korpa) {
    if (!kontejner) return;
    var ispod = korpa.total_price < MIN;
    var o = kontejner.querySelector('.sh-min-obavestenje');
    if (!o) {
      o = document.createElement('div');
      o.className = 'sh-min-obavestenje';
      kontejner.insertBefore(o, kontejner.firstChild);
    }
    if (ispod) {
      o.style.cssText = 'margin:0 0 1.2rem;padding:1.1rem 1.3rem;border:1px solid #b3261e;' +
        'background:#fdeceb;color:#8c1d18;font-size:1.4rem;line-height:1.5;' +
        'border-radius:6px;text-align:center';
      o.innerHTML = '<strong>Minimalna vrednost porudžbine je 1.000 RSD.</strong><br>' +
        'Trenutno u korpi: ' + dinara(korpa.total_price) + ' RSD. Nedostaje još ' +
        dinara(MIN - korpa.total_price) + ' RSD.';
    } else {
      o.style.cssText = 'margin:0 0 1.2rem;padding:0.9rem 1.2rem;border:1px solid #d9d9d9;' +
        'background:#f6f6f6;color:#444;font-size:1.3rem;line-height:1.5;' +
        'border-radius:6px;text-align:center';
      o.textContent = 'Napomena: minimalna vrednost porudžbine je 1.000 RSD.';
    }
  }

  function ocisti() {
    document.querySelectorAll('.sh-min-obavestenje, .sh-min-poruka')
      .forEach(function (p) { p.remove(); });
  }

  function primeni(korpa) {
    if (korpa.item_count === 0) { ocisti(); return; }
    var ispod = korpa.total_price < MIN;

    document.querySelectorAll('button[name="checkout"], .cart__checkout-button, #CartDrawer-Checkout')
      .forEach(function (b) {
        b.disabled = ispod;
        b.style.opacity = ispod ? '0.45' : '';
        b.style.cursor = ispod ? 'not-allowed' : '';
      });

    document.querySelectorAll('.cart__dynamic-checkout-buttons, .additional-checkout-buttons, .dynamic-checkout__content')
      .forEach(function (d) { d.style.display = ispod ? 'none' : ''; });

    nadjiMesta().forEach(function (m) { obavestenje(m, korpa); });
  }

  function proveriKupiOdmah() {
    document.querySelectorAll('.shopify-payment-button').forEach(function (d) {
      var forma = d.closest('form[action*="/cart/add"]');
      var cena = null;
      if (forma) {
        var polje = forma.querySelector('[name="id"]');
        var kol = forma.querySelector('[name="quantity"]');
        var kom = kol ? parseInt(kol.value, 10) || 1 : 1;
        if (window.__shMinCena != null) cena = window.__shMinCena * kom;
        if (polje && window.__shVarijante && window.__shVarijante[polje.value] != null) {
          cena = window.__shVarijante[polje.value] * kom;
        }
      }
      if (cena != null) d.style.display = cena < MIN ? 'none' : '';
    });
  }

  function proveri() {
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(primeni)
      .catch(function () {});
    proveriKupiOdmah();
  }

  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (f && f.action && f.action.indexOf('/cart') > -1) {
      var dugme = f.querySelector('button[name="checkout"]');
      if (dugme && dugme.disabled) { e.preventDefault(); }
    }
  }, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', proveri);
  } else {
    proveri();
  }
  document.addEventListener('click', function () { setTimeout(proveri, 700); });
  document.addEventListener('change', function () { setTimeout(proveri, 700); });
  setInterval(proveri, 2500);
})();
